import React from 'react'
import {
  BrowserRouter as Router,
} from 'react-router-dom'
import styled, { ThemeProvider } from 'styled-components'
import theme from '../theme'
import ScrollToTop from './ScrollToTop'
import Form from './Form'
import Navbar from './Navbar'

const Container = styled.div`
`

const InnerContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 50px 20px;
`

export default () => (
  <Router>
    <ScrollToTop>
      <ThemeProvider theme={theme}>
        <Container>
          <Navbar />
          <InnerContainer>
            <Form />
          </InnerContainer>
        </Container>
      </ThemeProvider>
    </ScrollToTop>
  </Router>
)
